import React, { useState } from "react";
import { translate } from "react-switch-lang";
import { Col, Form, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from "reactstrap";
import { Language } from "../../../models/language";
import Dropzone from "react-dropzone-uploader";
import ButtonComponent from "../../button-componenet/buttonComponent";
import styles from "./addFolderThematic.module.scss";
import { DropZoneEventDto } from "../../../models/dropZoneEventDto";
import { FileStatus } from "../../../models/fileStatus";
import { IMAGE_EXTENTION } from "../../../Data/extentionImage";
import { toast } from "react-toastify";
import { useHttpClient } from "../../../security/hooks/axiosProvider";

const AddFolderThematic: React.FC<{
  t: (key: string) => {};
  isOnCreate: boolean;
  modal: boolean;
  toggle: (isOncreate: boolean) => void;
  isShowDropZone: boolean;
  setIsShowDropZone: (isShowDropZone: boolean) => void;
  editFolderData: any;
  parentId: number;
  categoryId: number;
  handleGetListFolderThematic: (id: number) => void;
  formValidation: boolean;
}> = props => {
  toast.configure();
  const httpClient = useHttpClient(true);
  const [errorsFrancais, setErrorsFrancais] = useState<string>("");
  const [errorsAnglais, setErrorsAnglais] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<any>();
  const [urlImage, setUrlImage] = useState<string>("");
  const pathFolder = "/Mediatheque/Categories/";
  const [titleFrancais, setTitleFrancais] = useState<string>(props?.editFolderData ? props?.editFolderData?.titleFrancais : "");
  const [titleAnglais, setTitleAnglais] = useState<string>(props?.editFolderData ? props?.editFolderData?.titleAnglais : "");
  const path = "/Mediatheque/image/";

  const handleChangeStatus = ({ meta, file }: DropZoneEventDto, status: string) => {
    if (status === FileStatus.REMOVED) {
      setSelectedFile(null);
    } else {
      if (IMAGE_EXTENTION.includes(file.name.slice(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase())) {
        if (status === FileStatus.DONE) {
          setSelectedFile(file);
          setUrlImage(meta.previewUrl);
        }
      } else {
        toast.error(String(props.t("message_extention_not_allowed")));
      }
    }
  };

  const handleSubmit = async () => {
    if (props.isOnCreate) {
      handleAddThematicFolder();
    } else {
      handleUpdateCategory();
    }
  };

  const handleAddThematicFolder = () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    httpClient.current
      ?.post(`/thematic_folder/files?path=${path}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        httpClient.current
          ?.post("/thematic_folder", {
            titleFrancais: titleFrancais,
            titleAnglais: titleAnglais,
            pathFolder: pathFolder,
            pathImage: response.data,
            parentId: props.parentId,
            categoryId: props.categoryId,
          })
          .then(response => {
            props.handleGetListFolderThematic(props.parentId);
            props.toggle(false);
          });
      });
  };

  const handleUpdateCategory = () => {
    const formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile);
      httpClient.current
        ?.put(`/thematic_folder/files?path=${props?.editFolderData?.pathImage}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(response => {
          httpClient.current
            ?.put("/thematic_folder", {
              thematicFolderId: props.editFolderData.thematicFolderId,
              titleFrancais: titleFrancais,
              titleAnglais: titleAnglais,
              pathFolder: props.editFolderData.pathFolder,
              pathImage: response.data,
              parentId: props.editFolderData.parentId,
              categoryId: props.categoryId,
            })
            .then(response => {
              props.handleGetListFolderThematic(props.parentId);
              toast.success(String(props.t("message_toastr_update")), {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 5000,
              });
              props.toggle(false);
            });
        });
    } else {
      if (titleFrancais !== props.editFolderData.titleFrancais || titleAnglais !== props.editFolderData.titleAnglais) {
        httpClient.current
          ?.put("/thematic_folder", {
            thematicFolderId: props.editFolderData.thematicFolderId,
            titleFrancais: titleFrancais,
            titleAnglais: titleAnglais,
            pathFolder: props.editFolderData.pathFolder,
            pathImage: props.editFolderData.pathImage,
            parentId: props.editFolderData.parentId,
          })
          .then(response => {
            props.handleGetListFolderThematic(props.parentId);
            toast.success(String(props.t("message_toastr_update")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            props.toggle(false);
          });
      } else {
        props.toggle(false);
      }
    }
  };

  const handleChangeTitle = (title: string, type: string) => {
    if (title.includes("/")) {
      if (type === Language.FRANCAIS) {
        setErrorsFrancais(String(props.t("message_invalid_caractere")));
      } else {
        setErrorsAnglais(String(props.t("message_invalid_caractere")));
      }
    } else {
      if (type === Language.FRANCAIS) {
        setTitleFrancais(title.trim());
      } else {
        setTitleAnglais(title.trim());
      }
    }
  };

  return (
    <>
      <ModalBody>
        <Form className="form-bookmark needs-validation">
          <div className="form-row">
            <FormGroup className="col-md-12">
              <Label>{props.t("folder_modale.label_name_fr")}*</Label>
              <div className="text-center">
                <Input
                  maxLength={100}
                  onChange={e => handleChangeTitle(e.target.value, Language.FRANCAIS)}
                  className={styles["input-name"] + " form-control"}
                  name="title"
                  type="text"
                  defaultValue={props.isOnCreate ? "" : props?.editFolderData?.titleFrancais}
                  autoComplete="off"
                  placeholder={String(props.t("folder_modale.label_name_fr"))}
                />
              </div>
              {errorsFrancais && <span className={styles["errors"]}>{errorsFrancais}</span>}
            </FormGroup>
            <FormGroup className="col-md-12">
              <Label>{props.t("folder_modale.label_name_en")}*</Label>
              <div className="text-center">
                <Input
                  maxLength={100}
                  onChange={e => handleChangeTitle(e.target.value, "anglais")}
                  className={styles["input-name"] + " form-control"}
                  name="title"
                  type="text"
                  defaultValue={props.isOnCreate ? "" : props?.editFolderData?.titleAnglais}
                  autoComplete="off"
                  placeholder={String(props.t("folder_modale.label_name_en"))}
                />
              </div>
              {errorsAnglais && <span className={styles["errors"]}>{errorsAnglais}</span>}
            </FormGroup>
            <FormGroup className="col-md-12">
              <div className={styles["input-file-image"]}>
                <input className="form-control" name="file" accept="image/*" id="upfile" multiple type="file" />
              </div>
            </FormGroup>
            <FormGroup className="col-md-12">
              <Row>
                <Col xl="12" sm="12" md={{ size: 12, offset: 0 }}>
                  <Label id="upload">{props.t("folder_modale.label_representative_image")}*</Label>
                  {props.isShowDropZone &&
                    (!selectedFile ? (
                      <Dropzone
                        onChangeStatus={handleChangeStatus}
                        maxFiles={1}
                        accept={"image/*"}
                        multiple={false}
                        canCancel={true}
                        inputContent={
                          <div key="1">
                            <span className={styles["drop-zone-title"]}>
                              <i className="fa fa-plus"></i> {props.t("folder_modale.label_choose_image")}
                            </span>
                            <div className={styles["label-drag-and-drop"]}>{props.t("folder_modale.label_drag_and_drop_here")}</div>
                          </div>
                        }
                        styles={{
                          dropzone: { width: "90%", height: 100, background: "#efefefbf", border: "none !important" },
                          dropzoneActive: { border: "none !important" },
                        }}
                      />
                    ) : (
                      <div className="text-center">
                        <div className={styles["uploadPictureP"]}>
                          <div onClick={() => setSelectedFile(null)} className={styles["deleteImage"]}>
                            <i className="fa fa-times-circle"></i>
                          </div>

                          {selectedFile.previewUrl}
                          <img className={styles["default-image-category"]} src={urlImage} alt="" />
                        </div>
                      </div>
                    ))}
                </Col>

                {!props.isShowDropZone && (
                  <Col xl="12" sm="12" md={{ size: 4, offset: 0 }}>
                    <div className="text-center">
                      <div className={styles["uploadPictureP"]}>
                        <div onClick={() => props.setIsShowDropZone(!props.isShowDropZone)} className={styles["deleteImage"]}>
                          <i className="fa fa-times-circle"></i>
                        </div>
                        <img className={styles["default-image-category"]} src={props?.editFolderData?.urlImage} alt="" />
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </FormGroup>
          </div>
        </Form>
      </ModalBody>

      <ModalFooter>
        <ButtonComponent onClick={props.toggle} disable={false} buttonType={"button"} buttonText={String(props.t("button_cancel"))} save={false} />
        <ButtonComponent
          onClick={handleSubmit}
          disable={titleAnglais.trim() === "" || titleFrancais.trim() === "" || (!selectedFile && props.isShowDropZone)}
          buttonType={"submit"}
          buttonText={String(props.t("button_submit"))}
          save={true}
        />
      </ModalFooter>
    </>
  );
};

export default translate(AddFolderThematic);
